import requests from '@/utils/requests'


// 获取用户信息是否登陆
export function userLogin(data) {
	return requests({
	    url: '/user/userLogin',
		headers: {'Content-Type':'application/json'},
	    method: 'POST',
		data
	})
}

// 获取报工分页模糊查询列表
export function reportList(data,token) {
	return requests({
	    url: '/report/list',
		headers: {'Content-Type':'application/json','Authorization':token},
	    method: 'POST',
		data
	})
}

// 获取工单分页模糊查询列表
export function orderList(data) {
	return requests({
	    url: '/order/list',
		headers: {'Content-Type':'application/json'},
	    method: 'POST',
		data
	})
}


// 批量删除工单
export function batchDeleteOrder(data) {
	return requests({
	    url: '/order/batchDeleteOrder',
		headers: {'Content-Type':'application/json'},
	    method: 'POST',
		data
	})
}
// 删除工单
export function deleteOrder(data) {
	return requests({
	    url: '/order/deleteOrder',
		headers: {'Content-Type':'application/json'},
	    method: 'POST',
		data
	})
}
// 删除工单
export function endOrder(data) {
	return requests({
	    url: '/order/updateStatus',
		headers: {'Content-Type':'application/json'},
	    method: 'POST',
		data
	})
}

// 全部产品信息列表
export function allProduct() {
	return requests({
	    url: '/product/allProduct',
		headers: {'Content-Type':'application/json'},
	    method: 'GET'
	})
}

// 产品信息分页模糊查询列表
export function productList(data) {
	return requests({
	    url: '/product/list',
		headers: {'Content-Type':'application/json'},
	    method: 'POST',
		data
	})
}

// 删除产品信息
export function deleteProduct(data) {
	return requests({
	    url: '/product/deleteProduct',
		headers: {'Content-Type':'application/json'},
	    method: 'POST',
		data
	})
}
// 批量删除产品信息
export function batchDeleteProduct(data) {
	return requests({
	    url: '/product/batchDeleteProduct',
		headers: {'Content-Type':'application/json'},
	    method: 'POST',
		data
	})
}
// 创建产品信息
export function createProduct(data) {
	return requests({
	    url: '/product/createProduct',
		headers: {'Content-Type':'multipart/form-data'},
	    method: 'POST',
		data
	})
}

// 全部单位列表
export function allUnit() {
	return requests({
	    url: '/unit/allUnit',
		headers: {'Content-Type':'application/json'},
	    method: 'GET'
	})
}

// 单位分页模糊查询列表
export function unitList(data) {
	return requests({
	    url: '/unit/list',
		headers: {'Content-Type':'application/json'},
	    method: 'POST',
		data
	})
}

// 全部路线列表
export function allRoute() {
	return requests({
	    url: '/route/allRoute',
		headers: {'Content-Type':'application/json'},
	    method: 'GET'
	})
}
// 路线分页模糊查询列表
export function routeLise(data) {
	return requests({
	    url: '/route/list',
		headers: {'Content-Type':'application/json'},
	    method: 'POST',
		data
	})
}
// 路线详情
export function detailRoute(data) {
	return requests({
	    url: '/route/detailRoute',
		headers: {'Content-Type':'application/json'},
	    method: 'POST',
		data
	})
}
// 创建路线
export function createRoute(data) {
	return requests({
	    url: '/route/createRoute',
		headers: {'Content-Type':'application/json'},
	    method: 'POST',
		data
	})
}
// 编辑路线
export function updateRoute(data) {
	return requests({
	    url: '/route/updateRoute',
		headers: {'Content-Type':'application/json'},
	    method: 'POST',
		data
	})
}
// 删除路线
export function deleteRoute(data) {
	return requests({
	    url: '/route/deleteRoute',
		headers: {'Content-Type':'application/json'},
	    method: 'POST',
		data
	})
}
// 批量删除路线
export function batchDeleteRoute(data) {
	return requests({
	    url: '/route/batchDeleteRoute',
		headers: {'Content-Type':'application/json'},
	    method: 'POST',
		data
	})
}

// 工序分页模糊查询列表
export function procedureList(data) {
	return requests({
	    url: '/procedure/list',
		headers: {'Content-Type':'application/json'},
	    method: 'POST',
		data
	})
}

// 全部工序列表
export function allProcedure(data) {
	return requests({
	    url: '/procedure/allProcedure',
		headers: {'Content-Type':'application/json'},
	    method: 'GET',
		data
	})
}

// 创建工序
export function createProcedure(data) {
	return requests({
	    url: '/procedure/createProcedure',
		headers: {'Content-Type':'application/json'},
	    method: 'POST',
		data
	})
}
// 删除工序
export function deleteProcedure(data) {
	return requests({
	    url: '/procedure/deleteProcedure',
		headers: {'Content-Type':'application/json'},
	    method: 'POST',
		data
	})
}

// 批量删除工序
export function batchDeleteProcedure(data) {
	return requests({
	    url: '/procedure/batchDeleteProcedure',
		headers: {'Content-Type':'application/json'},
	    method: 'POST',
		data
	})
}
// 工序详情
export function detailProcedure(data) {
	return requests({
	    url: '/procedure/detailProcedure',
		headers: {'Content-Type':'application/json'},
	    method: 'POST',
		data
	})
}
// 编辑工序
export function updateProcedure(data) {
	return requests({
	    url: '/procedure/updateProcedure',
		headers: {'Content-Type':'application/json'},
	    method: 'POST',
		data
	})
}



// 创建工单
export function createOrder(data) {
	return requests({
	    url: '/order/createOrder',
		headers: {'Content-Type':'multipart/form-data'},
	    method: 'POST',
		data
	})
}



// 工单详情
export function detailOrder(data) {
	return requests({
	    url: '/order/detailOrder',
		headers: {'Content-Type':'application/json'},
	    method: 'POST',
		data
	})
}


// 删除工单图纸
export function deleteFile(data) {
	return requests({
	    url: '/order/deleteFile',
		headers: {'Content-Type':'application/json'},
	    method: 'POST',
		data
	})
}
// 删除产品图纸
export function productDeleteFile(data) {
	return requests({
	    url: '/product/deleteFile',
		headers: {'Content-Type':'application/json'},
	    method: 'POST',
		data
	})
}

// 产品信息详情
export function detailProduct(data) {
	return requests({
	    url: '/product/detailProduct',
		headers: {'Content-Type':'application/json'},
	    method: 'POST',
		data
	})
}
// 编辑产品信息
export function updateProduct(data) {
	return requests({
	    url: '/product/updateProduct',
		headers: {'Content-Type':'multipart/form-data'},
	    method: 'POST',
		data
	})
}


// 编辑工单
export function updateOrder(data) {
	return requests({
	    url: '/order/updateOrder',
		headers: {'Content-Type':'multipart/form-data'},
	    method: 'POST',
		data
	})
}

// 绩效分页模糊查询列表
export function meritList(data) {
	return requests({
	    url: '/merit/list',
		headers: {'Content-Type':'application/json'},
		method: 'POST',
		data
	})
}
// 删除绩效
export function meritDeleteMerit(data) {
	return requests({
	    url: '/merit/deleteMerit',
		headers: {'Content-Type':'application/json'},
		method: 'POST',
		data
	})
}

// 批量删除绩效
export function batchDeleteMerit(data) {
	return requests({
	    url: '/merit/batchDeleteMerit',
		headers: {'Content-Type':'application/json'},
		method: 'POST',
		data
	})
}

// 创建绩效
export function createMerit(data) {
	return requests({
	    url: '/merit/createMerit',
		headers: {'Content-Type':'application/json'},
		method: 'POST',
		data
	})
}

// 绩效详情
export function detailMerit(data) {
	return requests({
	    url: '/merit/detailMerit',
		headers: {'Content-Type':'application/json'},
		method: 'POST',
		data
	})
}

// 编辑绩效
export function updateMerit(data) {
	return requests({
	    url: '/merit/updateMerit',
		headers: {'Content-Type':'application/json'},
		method: 'POST',
		data
	})
}


// 删除报工
export function deleteReport(data) {
	return requests({
	    url: '/report/deleteReport',
		headers: {'Content-Type':'application/json'},
		method: 'POST',
		data
	})
}

// 批量删除报工
export function batchDeleteReport(data) {
	return requests({
	    url: '/report/batchDeleteReport',
		headers: {'Content-Type':'application/json'},
		method: 'POST',
		data
	})
}

// 报工详情
export function detailReport(data) {
	return requests({
	    url: '/report/detailReport',
		headers: {'Content-Type':'application/json'},
		method: 'POST',
		data
	})
}
// 报工审核
export function updateReportStatus(data) {
	return requests({
	    url: '/report/updateReportStatus',
		headers: {'Content-Type':'application/json'},
		method: 'POST',
		data
	})
}

// 主管分页模糊查询列表
export function managerList(data) {
	return requests({
	    url: '/user/managerList',
		headers: {'Content-Type':'application/json'},
		method: 'POST',
		data
	})
}

//删除用户
export function deleteUser(data) {
	return requests({
	    url: '/user/deleteUser',
		headers: {'Content-Type':'application/json'},
		method: 'POST',
		data
	})
}

//批量删除用户
export function batchDeleteUser(data) {
	return requests({
	    url: '/user/batchDeleteUser',
		headers: {'Content-Type':'application/json'},
		method: 'POST',
		data
	})
}


//创建用户
export function createUser(data) {
	return requests({
	    url: '/user/createUser',
		headers: {'Content-Type':'application/json'},
		method: 'POST',
		data
	})
}

//用户详情
export function detailUser(data) {
	return requests({
	    url: '/user/detailUser',
		headers: {'Content-Type':'application/json'},
		method: 'POST',
		data
	})
}

//编辑用户
export function updateUser(data) {
	return requests({
	    url: '/user/updateUser',
		headers: {'Content-Type':'application/json'},
		method: 'POST',
		data
	})
}

//工人分页模糊查询列表
export function userList(data) {
	return requests({
	    url: '/user/userList',
		headers: {'Content-Type':'application/json'},
		method: 'POST',
		data
	})
}

//用户修改密码
export function updateLoginPwd(data) {
	return requests({
	    url: '/user/updateLoginPwd',
		headers: {'Content-Type':'application/json'},
		method: 'POST',
		data
	})
}

//用户详情
export function resetPassword(data) {
	return requests({
		url: '/user/resetUserPass',
		headers: {'Content-Type':'application/json'},
		method: 'POST',
		data
	})
}

//导出
export function meritExport(data) {
	return requests({
		url: '/merit/meritExport',
		headers: {'Content-Type':'application/json'},
		method: 'POST',
		data,
		responseType: 'blob', // 重点，responseType设置为 blob
	})
}

//工资报表
export function salary(data) {
	return requests({
		url: '/report/salary',
		headers: {'Content-Type':'application/json'},
		method: 'POST',
		data
	})
}

//导出全部工资报表--浏览器直接下载文件
export function salaryExport(data) {
	return requests({
		url: '/report/salaryExport',
		headers: {'Content-Type':'application/json'},
		method: 'post',
		responseType: 'blob', // 重点，responseType设置为 blob
		data
	})
}


//主管下的工人分页模糊查询列表
export function manageUserList(data) {
	return requests({
		url: '/user/manageUserList',
		headers: {'Content-Type':'application/json'},
		method: 'POST',
		data
	})
}
//批量删除主管下的工人
export function batchDeleteManageWorker(data) {
	return requests({
		url: '/user/batchDeleteManageWorker',
		headers: {'Content-Type':'application/json'},
		method: 'POST',
		data
	})
}
//批量删除主管下的工人
export function deleteManageWorker(data) {
	return requests({
		url: '/user/deleteManageWorker',
		headers: {'Content-Type':'application/json'},
		method: 'POST',
		data
	})
}

//主管添加工人
export function manageAddWorker(data) {
	return requests({
		url: '/user/manageAddWorker',
		headers: {'Content-Type':'application/json'},
		method: 'POST',
		data
	})
}

//全部用户列表
export function allUser() {
	return requests({
		url: '/user/allUser',
		headers: {'Content-Type':'application/json'},
		method: 'GET'
	})
}
//编辑报工记录
export function bgupdateReport(data) {
	return requests({
		url: '/report/updateReport',
		headers: {'Content-Type':'application/json'},
		method: 'POST',
		data
	})
}

//获取报工列表
export function bgjllist(data) {
	return requests({
		url: '/order/list',
		headers: {'Content-Type':'application/json'},
		method: 'POST',
		data
	})
}



